import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { STORAGE_KEYS } from '../constants/storage.constants';

export const authGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  let tokenInStorage: string | null = null;
  try {
    tokenInStorage = sessionStorage.getItem(STORAGE_KEYS.AUTH_TOKEN);
  } catch {
    // Ignore
  }

  if (authService.isAuthenticated() && tokenInStorage) {
    return true;
  }

  return router.createUrlTree(['/auth/login']);
};
